$(function() {
  var $block = $('.b-header-sticky');
  var $wrapper = $block.find('.outer-wrapper');

  if (! $block.length ) {
    return;
  }

  var distance = $block.offset().top,
      height = $wrapper.height(),
      scroll;

  $(document).on('scroll', function() {
    scroll = $(document).scrollTop();

    if (scroll > distance) {
      $wrapper.addClass('stuck');
      $block.css('min-height', height);
    }

    else {
      $wrapper.removeClass('stuck');
    }
  });
});
